import { BrutalistBadge, GlassCard, SolidBlock } from "@/app/components/brand-scaffold";

const glassCardProps = {
  bgClass: "bg-white/75",
  hoverClass: "hover:bg-white/95",
  className: "!p-4 flex-1 flex flex-col",
} as const;

export function HomepageCallFlow() {
  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
      <div className="mx-auto max-w-5xl">
        <div className="mb-8">
          <BrutalistBadge bgClass="bg-[#3B82F6]" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white" className="text-white">
            HOW A CALL WORKS
          </BrutalistBadge>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-black mb-10">
          一次调用怎么发生？
        </h2>
        <div className="space-y-6">
          {callFlowSteps.map((step, idx) => (
            <div key={step.title} className="flex gap-4 items-start">
              <div className={`flex-shrink-0 w-12 h-12 flex items-center justify-center border-4 border-black font-black text-lg ${step.bg}`}>
                {idx + 1}
              </div>
              <GlassCard {...glassCardProps}>
                <h3 className="font-black text-black">{step.title}</h3>
                <p className="text-sm text-zinc-700 mt-1">{step.desc}</p>
              </GlassCard>
            </div>
          ))}
        </div>
        <SolidBlock bgClass="bg-[#A3E635] text-black" className="!p-5 mt-10">
          <p className="font-black text-black">
            核心原则：契约公开，实现私有。
          </p>
          <p className="text-sm text-zinc-800 mt-1">
            Agent 看到 schema 和 result_package，不看到你的源码、prompt、模型或内部工作流。
          </p>
        </SolidBlock>
      </div>
    </section>
  );
}

const callFlowSteps = [
  { title: "Agent / Caller 发起任务请求", desc: "通过 delexec-ops CLI 或 SDK 向 catalog 发起调用。", bg: "bg-[#14B8A6]" },
  { title: "Supervisor 处理会话", desc: "本地 supervisor 管理会话、catalog 查询和调用状态。", bg: "bg-[#3B82F6] text-white" },
  { title: "Hotline Contract 校验", desc: "定义输入、输出、版本和风险，确保调用符合契约。", bg: "bg-[#A3E635]" },
  { title: "Responder Adapter 本地执行", desc: "你的私有实现在本地执行，核心逻辑不出边界。", bg: "bg-[#F97316] text-white" },
  { title: "result_package 返回", desc: "标准化结果返回给 Caller，包含输出、耗时、状态。", bg: "bg-[#8B5CF6] text-white" },
];
